/* Match only neighbouring cards: short rows stay compact, long rows align. */
(() => {
  const gridSelector = '.ob-products-grid, #collection-products.grid-products';
  const slots = ['.ob-vendor', '.ob-product-title', '.ob-product-meta', '.ob-ean', '.ob-card-price', '.ob-tax', '.ob-availability', '.ob-pack'];
  let frame = 0;
  const observed = new WeakSet();
  const widths = new WeakMap();
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; align(); });
  };
  const resize = window.ResizeObserver && new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (widths.get(entry.target) !== width) { widths.set(entry.target, width); schedule(); }
    }
  });
  function align() {
    document.querySelectorAll(gridSelector).forEach(grid => {
      if (!observed.has(grid)) { observed.add(grid); resize?.observe(grid); }
      const cards = [...grid.querySelectorAll('.ob-product:not(.ob-product--list)')];
      cards.forEach(card => card.querySelector('.ob-product-info').style.removeProperty('grid-template-rows'));
      const rows = [];
      cards.forEach(card => {
        if (!card.getClientRects().length) return;
        const top = card.getBoundingClientRect().top;
        let row = rows.find(row => Math.abs(row.top - top) < 3);
        if (!row) rows.push(row = { top, cards: [] });
        row.cards.push(card);
      });
      const changes = [];
      rows.filter(row => row.cards.length > 1).forEach(row => {
        const heights = slots.map(selector => Math.max(...row.cards.map(card => {
          const node = card.querySelector(selector);
          if (!node || !node.getClientRects().length) return 0;
          const style = getComputedStyle(node);
          return node.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
        })));
        row.cards.forEach(card => changes.push([card.querySelector('.ob-product-info'), heights.map(h => `${Math.ceil(h)}px`).join(' ')]));
      });
      changes.forEach(([info, rows]) => { info.style.gridTemplateRows = rows; });
    });
  }
  // AJAX filters, pagination and the home shelf all replace card markup.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches?.('.ob-product, ' + gridSelector) || node.querySelector?.('.ob-product'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();

  const desktop = matchMedia('(min-width: 768px)');
  function footer() {
    document.querySelectorAll('.ob-footer-group').forEach(group => { group.open = desktop.matches; });
  }
  desktop.addEventListener('change', footer);
  document.addEventListener('shopify:section:load', footer);
  footer();
})();
